import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatSnackBar } from '@angular/material';

import { OpcionModel } from '../Global/Opcion.model';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import * as sucursalModel from './Sucursal.model'
import { IfObservable } from 'rxjs/observable/IfObservable';
import { Console } from '@angular/core/src/console';

@Component({
	selector: 'SucursalForm',
	templateUrl: './SucursalForm.component.html'
})


export class SucursalFormComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form: FormGroup;
	public formErrors: any;
	public sucursal: sucursalModel.SucursalModel;
	public ciudades: Array<OpcionModel>;
	public departamentos: Array<OpcionModel>;
	public paises: Array<OpcionModel>;
	public registroSucursal;
	public mensaje: string;
	public principal: boolean;
	public guardando: boolean = false;
	public codigosPostales = new Array();
	public bloquearValor:boolean = true;

	public ocultar: boolean = false;


	constructor(private formBuilder: FormBuilder,
		private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.formErrors = {

			direccion: {},
			departamento: {},
			ciudad: {},
			telefono: {},
			correo: {},
			principal: {},
			codigoPostal : {},
			pais :{},
			deptoextranjero :{},
			ciudadextranjero :{}
		}

		this.principal = false;
		this.ciudades = new Array();
		this.departamentos = new Array();
		this.paises = new Array();
		this.sucursal = new sucursalModel.SucursalModel(new sucursalModel.MchSucursalesId("", "", "", "")
			, "", "", new sucursalModel.DefCiudades(new sucursalModel.DefCiudadesId(0, "",""), ""), "", 0, 0, 0, 0, '','','');
	}

	ngOnInit() {

		this.inicializarForm();


		this._route.params.subscribe(params => {
			this.registroSucursal = [{
				'cnumcont': params['cnumcont'],
				'ctipid': params['ctipid'],
				'cnumid': params['cnumid'],
				'vnombre': params['vnombre'],
				'cidregter': params['cidregter'],
				'tipo': params['tipo'],
				'desde': params['desde'],
				'creaSucursal': params['creaSucursal']
			}];
		}
		)
		
		this.inicializarInformacion();

		if (this.registroSucursal[0].tipo == 'actualizar') {
			this.cargarSucursal();
			
		} else if (this.registroSucursal[0].tipo == 'insertar') {
			
			this.sucursal = new sucursalModel.SucursalModel(new sucursalModel.MchSucursalesId(this.registroSucursal[0].cnumcont,
				this.registroSucursal[0].ctipid,
				this.registroSucursal[0].cnumid,
				"")
				, "", "", new sucursalModel.DefCiudades(new sucursalModel.DefCiudadesId(0, "",""), ""), "", 0, 0, 0, 0, '','','');
			
				console.log(this.sucursal);
		}
		this.mensaje = this.registroSucursal[0].tipo;
	}




	inicializarForm() {
		this.form = this.formBuilder.group({

			direccion: ['', Validators.required],
			departamento: [{
				value   : this.sucursal.defCiudades.id.ccodigodepto
			}, Validators.required],
			ciudad: [{
				value   : this.sucursal.defCiudades.id.ccodigociudad
			} ,Validators.required],
			telefono : ['', Validators.compose([Validators.maxLength(100)])],
			correo: [''],
			codigoPostal : ['', Validators.required],
			pais : ['', Validators.required],
			deptoextranjero : [
				{
					value   : this.sucursal.deptoextranjero,
					disabled: this.bloquearValor
				},Validators.required
				],

				ciudadextranjero : [
					{
						value   : this.sucursal.ciudadextranjero,
						disabled: this.bloquearValor
					},Validators.required
					],
		});
	}




	inicializarInformacion() {

		this._serviciosGenerales.get('codigosPostales', { param: 0 }).subscribe(
			result => {
				for (let x of result){
					this.codigosPostales.push(x.codigo);
				}
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los códigos postales", "X");
			}
		);

	
		this._serviciosGenerales.get('paises', { param: 0 }).subscribe(
			result => {
				for (let x of result)
					this.paises.push(new OpcionModel(x.ccodigopais, x.vnombre));
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los paises", "X");
			}
		);

	/*
		this._serviciosGenerales.get('departamentos', { param: 0 }).subscribe(
			result => {
				for (let x of result)
					this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de cargar los tipos departamentos", "X");
			}
		);	
		*/

	
	}


	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	cargarSucursal() {


		this.sucursal = new sucursalModel.SucursalModel(new sucursalModel.MchSucursalesId("", "", "", "")
		, "", "", new sucursalModel.DefCiudades(new sucursalModel.DefCiudadesId(0, "",""), ""), "", 0, 0, 0, 0, '','','');
		

		this._serviciosGenerales.get('sucursalEspecifica',
			{
				cnumcont: this.registroSucursal[0].cnumcont,
				ctipid: this.registroSucursal[0].ctipid,
				cnumid: this.registroSucursal[0].cnumid,
				cidregter: this.registroSucursal[0].cidregter
			}).subscribe(result => {

				for (let x of result) {

					this.sucursal = new sucursalModel.SucursalModel(new sucursalModel.MchSucursalesId(
						this.registroSucursal[0].cnumcont,
						this.registroSucursal[0].ctipid,
						this.registroSucursal[0].cnumid,
						this.registroSucursal[0].cidregter), x.vdireccion, x.vtelefono,
						new sucursalModel.DefCiudades(new sucursalModel.DefCiudadesId(x.codciudad, x.coddepto,x.ccodigopais.trim()), ""),
						//new sucursalModel.DefDepartamentos(x.vdepto,x.coddepto),
						/*new sucursalModel.DefCiudades(x.vciudad,x.codciudad),*/
						x.vcorreo.trim(), 0,
						x.nprincipal, 0, 0, x.vpostal ,x.deptoextranjero,x.ciudadextranjero);
				}
				this._serviciosGenerales.get('ciudades', { ccodigodepto: this.sucursal.defCiudades.id.ccodigodepto }).subscribe(
					result => {
						for (let x of result)
							this.ciudades.push(new OpcionModel(x.ccodigociudad, x.vnombre));
					},
					error => {
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
					}
				);

				this._serviciosGenerales.get('departamentosCargue', { ccodigodepto: this.sucursal.defCiudades.id.ccodigodepto }).subscribe(
					result => {
						for (let x of result)
							this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
					},
					error => {
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
					}
				);
				
						
				if(this.sucursal.defCiudades.id.ccodigopais.trim()!='169'){
					console.log("Michael Villamil ");
					
					//this.form.get('departamento').setValue('0');
					//this.consultarCiudades(0);
					//this.form.get('ciudad').setValue('0');
					this.form.get('departamento').disable();
					this.form.get('ciudad').disable();
					this.form.get('deptoextranjero').enable();
					this.form.get('ciudadextranjero').enable();
				}
				

				if (this.sucursal.nprincipal == 0) {
					this.principal = false
				} else if (this.sucursal.nprincipal == 1) {
					this.principal = true
				}


			},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar la sucursal", "X");
				});


		


	}

	consultarCiudades(id: number) {
		this.ciudades = new Array();
		this.sucursal.defCiudades.id.ccodigociudad = 0;
		this._serviciosGenerales.get('ciudades', { ccodigodepto: this.sucursal.defCiudades.id.ccodigodepto }).subscribe(
			result => {
				for (let x of result)
					this.ciudades.push(new OpcionModel(x.ccodigociudad, x.vnombre));
				/*if(id > -1)
					this.sucursal.defCiudades.id.ccodigociudad = id;*/
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
			}
		);
	}

	consultarDepartamentos(id: number){
		this.departamentos = new Array();
		this.sucursal.defCiudades.id.ccodigodepto = "";
		this.sucursal.defCiudades.id.ccodigociudad = 0;


		
		this._serviciosGenerales.get('departamentosPorPais', { ccodigopais: this.sucursal.defCiudades.id.ccodigopais }).subscribe(
			result => {
				for (let x of result)
					this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
					this.validarCampo(true);
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
			}
		);
	}


	guardar() {


		var sucursalCodigoPostal = this.sucursal.vpostal

		var resultado1 = this.codigosPostales.find(function (x) {
			return x === sucursalCodigoPostal;
		});
		//console.log('this.sucursal.defCiudades.id.ccodigopais ',this.sucursal.defCiudades.id.ccodigopais);

		if(resultado1 == undefined && this.sucursal.defCiudades.id.ccodigopais =='169'){
			this.openSnackBarEspecial('El código Postal : ' + sucursalCodigoPostal + ' No esta definido dentro de los posibles códigos postales del país.', 'X');
			return;
		}


		if ((this.sucursal.defCiudades.id.ccodigociudad == 0 || this.sucursal.defCiudades.id.ccodigociudad == null) && this.sucursal.defCiudades.id.ccodigopais =='169') {
			this.openSnackBarEspecial('Ciudad invalida, seleccione una ciudad de la lista', 'X');
			return;
		}

		var regex = new RegExp(/^[0-9]*$/);

		if (regex.test(this.sucursal.vtelefono) == false) {
			this.openSnackBarEspecial('Número de teléfono no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios , ni letras ', 'X');
			return;
		}

		
		var correos = this.sucursal.vcorreo.split(";")
		
		for (var c of correos) {
			
			var reg = new RegExp(/[\w.+-]+@[\w.+-]+\.[a-zA-Z0-9]{2,4}(,\s*)*/ig);

			c = c.split(' ').join("");
			  var resultest =reg.test(c);
			  console.log(resultest, "=====>");

			/*
			  console.log(c, "=====>", reg.test(c));

			
			console.log(reg.test(c) == false);
			console.log(JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa != 1);
			console.log(reg.test(c) == false && JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa != 1);
*/

			if ((resultest == false) && (JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa != 1)) {
				this.openSnackBarEspecial('Correo no valido, ingrese  un correo una dirección de correo validar , además si desea ingresar varios correos estos deben estar separados por punto y coma ', 'X');
				return;
			}



			if (JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa == 1 && c != '') {
				if (resultest == false) {
					this.openSnackBarEspecial('Correo no valido, ingrese  un correo una dirección de correo valida , además si desea ingresar varios correos estos deben estar separados por punto y coma', 'X');
					return;
				}
			}


		}



		if (this.principal == false) {
			this.sucursal.nprincipal = 0
		} else if (this.principal == true) {
			this.sucursal.nprincipal = 1
		}

		if(this.sucursal.defCiudades.id.ccodigopais.trim()!='169'){
			this.sucursal.defCiudades.id.ccodigodepto ='0'
			this.sucursal.defCiudades.id.ccodigociudad = 0
		}

		this._serviciosGenerales.get('validarSucursal', { cnumcont: this.registroSucursal[0].cnumcont, cnumdid: this.registroSucursal[0].cnumid, cidregter: this.sucursal.id.cidregter }).subscribe(
			result => {

				if (result[0].c > 0 && this.registroSucursal[0].tipo != 'actualizar') {
					this.openSnackBarEspecial('La Sucursal : ' + this.sucursal.id.cidregter + ' ya existe en el sistema para el tercero ' + this.registroSucursal[0].cnumid, 'X');
					return;
				} else {
						console.log("Pepito===>",this.sucursal)
					this._serviciosGenerales.post('guardar/sucursal', this.sucursal).subscribe(
						result => {
							this.openSnackBar("Proceso realizado con éxito", "X");

							this._router.navigate(['/Sucursal', this.registroSucursal[0].cnumcont, this.registroSucursal[0].ctipid, this.registroSucursal[0].cnumid, this.registroSucursal[0].vnombre, this.registroSucursal[0].desde]);

							this.sucursal = new sucursalModel.SucursalModel(new sucursalModel.MchSucursalesId("", "", "", "")
								, "", "", new sucursalModel.DefCiudades(new sucursalModel.DefCiudadesId(0, "",""), ""), "", 0, 0, 0, 0, '','','');


							this.cargarSucursal();
						},
						error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBar("Ocurrió un error al momento de guardar la sucursal", "X");
						}

					)
				}
			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de validar el prefijo", "X");
				return;
			})



	}

	public validarCampo(x){
		
		console.log('vegeta ',this.sucursal.defCiudades.id.ccodigopais);

		if(this.sucursal.defCiudades.id.ccodigopais!='169'){

			this.bloquearValor = true;
			this.form.get('departamento').setValue('0');
			//this.consultarCiudades(0);
			//this.form.get('ciudad').setValue('0');
			this.form.get('departamento').disable();
			this.form.get('ciudad').disable();
			this.form.get('deptoextranjero').enable();
			this.form.get('ciudadextranjero').enable();
		
		}
		else{
			this.bloquearValor = false;
			//this.form.get('departamento').setValue('');
			this.form.get('departamento').enable();
			this.form.get('ciudad').setValue('0');
			this.form.get('ciudad').enable();
			this.form.get('deptoextranjero').setValue('');
			this.form.get('ciudadextranjero').setValue('');
			this.form.get('deptoextranjero').disable();
			this.form.get('ciudadextranjero').disable();
		}
	}


	quitarBlancos() {
		if (this.sucursal.vdireccion.split(' ').join('') == '') {
			this.sucursal.vdireccion = this.sucursal.vdireccion.split(' ').join('');

		}
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Tercero/SucursalForm.component.ts